module.exports = function getResource(label, vars = []) {
    let resources = {
        seeMore: 'Voir plus',
        inTheGallery: 'dans la galerie'
    };
    return resources[label];
};
